import { MealPlanAnalyticsLocation } from 'common/events/ClientEvents';
import React from 'react';
import { HeartToggleButton } from 'src/shared/design-system/HeartToggleButton';
import { useFollowButton } from './hooks';
import { UseIsFollowingProps } from './types';

interface FavoriteButtonProps extends UseIsFollowingProps {
  shefName: string;
  shefId: string;
  analyticsLocation: MealPlanAnalyticsLocation;
  className?: string;
  onAfterUnfavorite?: (shefId: string) => void;
  onAfterUndo?: (shefId: string) => void;
}

export const FavoriteButton: React.FC<FavoriteButtonProps> = ({
  shefName,
  shefId,
  analyticsLocation,
  className = 'size-14',
  onAfterUnfavorite,
  onAfterUndo,
}) => {
  const { buttonProps } = useFollowButton({
    name: shefName,
    shefId,
    location: analyticsLocation,
    onAfterUnfavorite,
    onAfterUndo,
  });
  const { isFollowing, onClick } = buttonProps;

  return <HeartToggleButton isActive={isFollowing} onToggle={onClick} className={className} />;
};
